import type { FaireProductEntity } from "../../entity_types/product";

export const matcha_9: FaireProductEntity = {
  token: "matcha-9",
  type: "product",
  name: "Handmade Ceramic Matcha Espresso Cup",
  brandName: "Holdydirtstudio",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/8cd9e5b6f21f8ae91e17e6bdb76a49b8c581f887811d068738aefd15a6c7f6bb.png",
  priceDollars: 3,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/8cd9e5b6f21f8ae91e17e6bdb76a49b8c581f887811d068738aefd15a6c7f6bb.png",
  weight: 0.5,
  dimensions: {
    width: 3,
    height: 4,
    depth: 3,
  },
  description: "Handmade ceramic matcha espresso cup",
  categoryTokens: ["cat_accessories"],
  tags: ["matcha", "ceramic", "cup", "handmade", "premium"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
